// src/store/slices/clientEntitySlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

interface MonthState {
  selectedMonth: string;
}
const isCxkpi = process.env.REACT_APP_ISCXKPI || false
const initialState: MonthState =
  isCxkpi ?
    {
      selectedMonth: dayjs().subtract(2, "month").toISOString()
    }
    :
    {
      selectedMonth: 
      // dayjs().date() > 15
      //   ? dayjs().toISOString()
        // : 
        dayjs().subtract(1, "month").toISOString()
    };
// const initialState: MonthState = {
//   selectedMonth: dayjs().subtract(2, "month").toISOString()
// };

const MonthSlice = createSlice({
  name: 'MonthSlice',
  initialState,
  reducers: {
    setSelectedMonth: (state, action: PayloadAction<string>) => {
      state.selectedMonth = action.payload;
    },

  },
});

export const { setSelectedMonth } = MonthSlice.actions;

export default MonthSlice.reducer;
